import register from '@kpsys/angularjs-register';
import AutocompleteSearchDataService from './autocomplete-search.data-service';
import {FormDataService} from './form.data-service';
import {DirectoryDataService} from './directory.data-service';
import ActionRequestDataService from './action-request-data.service';

export default register('portaro.shared.data-services')
    .service(ActionRequestDataService.serviceName, ActionRequestDataService)
    .service(AutocompleteSearchDataService.serviceName, AutocompleteSearchDataService)
    .service(FormDataService.serviceName, FormDataService)
    .service(DirectoryDataService.serviceName, DirectoryDataService)
    .name();
